<app-aggregated-amount-item
  name="フィジカル消化数"
  icon="./assets/universal_music.png"
  amount="{{ (posPhysicalEstimateModel$ | async)?.units }}"
  [hasAmount]="(posPhysicalEstimateModel$ | async)?.hasUnits"
  unit="消化数（実売数）"
  [rate]="(posPhysicalEstimateModel$ | async)?.rate"
  link=""
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のフィジカル消化数 (実売数) です。フィジカル消化数 (実売数) は選択期間内の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
